import { NavigationPage } from '@/app/components'
import useViewModel from './useViewModel'
import DeviceConnectionRedirect, {
  ConnectionStatusMode,
} from '@/authenticated/components/DeviceConnectionRedirect'
import { useNavigation } from '@/app/hooks'
import { Redirect } from 'react-router-dom'
import { match, P } from 'ts-pattern'

function TeslaFleetRedirectContent(props: ReturnType<typeof useViewModel>) {
  const {
    initializedEnergySystems,
    authenticatedEnergySystem,
    missingPermissions,
    ...deviceConnectionRedirectProps
  } = props
  const navigation = useNavigation()

  const handleBackClick = () => {
    navigation.go(-2) // skip past the tesla auth page
  }

  return match({
    mode: props.mode,
    systemsCount: initializedEnergySystems.length,
    authenticatedEnergySystem,
    missingPermissions,
  })
    .with(
      {
        mode: ConnectionStatusMode.Connected,
        systemsCount: 0,
        authenticatedEnergySystem: P.not(P.nullish),
      },
      ({ authenticatedEnergySystem }) => (
        <Redirect
          to={`/tesla-authentication/energy-system/no-system-information/${authenticatedEnergySystem.id}`}
        />
      ),
    )
    .with(
      {
        mode: ConnectionStatusMode.Connected,
        authenticatedEnergySystem: P.not(P.nullish),
      },
      ({ authenticatedEnergySystem }) => (
        <Redirect
          to={`/tesla-authentication/energy-system/verify-permissions/${authenticatedEnergySystem.id}`}
        />
      ),
    )
    .with(
      {
        mode: ConnectionStatusMode.Connected,
        authenticatedEnergySystem: P.not(P.nullish),
        missingPermissions: true,
      },
      ({ authenticatedEnergySystem }) => (
        <Redirect
          to={`/tesla-authentication/energy-system/no-system-information/${authenticatedEnergySystem.id}`}
        />
      ),
    )
    .otherwise(() => (
      <DeviceConnectionRedirect
        {...deviceConnectionRedirectProps}
        backButtonAction={handleBackClick}
      />
    ))
}

export default function TeslaAuthEnergySystemRedirectPage() {
  const viewModel = useViewModel()

  return (
    <NavigationPage id="tesla-fleet-redirect">
      <TeslaFleetRedirectContent {...viewModel} />
    </NavigationPage>
  )
}
